import { axiosInstance } from "../../../axios/axiosInstance";

const API_WALLET_TRANSACTIONS_URL = "admin/wallet";
const API_WALLET_TRANSACTIONS_MODULE_LIST_URL =
  API_WALLET_TRANSACTIONS_URL + "/all_wallet_transactions";

export const getWalletTransactions = (dataToBeSent) => {
  return axiosInstance.post(
    API_WALLET_TRANSACTIONS_MODULE_LIST_URL +
      `?search=${dataToBeSent.search ? dataToBeSent.search : ""}&page=${
        dataToBeSent.page ? dataToBeSent.page : ""
      }&size=${dataToBeSent.limit ? dataToBeSent.limit : ""}&role=${dataToBeSent?.role || ""}`
  );
};
